import classNames from 'classnames';
import styled from 'styled-components';
import AnimateHeight from 'react-animate-height';
import startcase from 'lodash.startcase';
import ButtonLink from '../shared/ButtonLinkComponent';
import { device } from '../../utils/styled-component-mixins';

const InsightWrapper = styled.div`
  display: flex;
  margin-bottom: 4rem;

  @media ${device.desktop} {
    margin-bottom: 6rem;
    max-width: 43.5rem;
  }

  button {
    border: none;
    padding-left: 3.2rem;
    text-align: left;
    width: 43.5rem;

    & h5 {
      color: var(--charcoal-2);
      font-size: 2rem;
      font-weight: 800;
      white-space: normal;

      @media ${device.desktop} {
        font-size: 2.2rem;
      }
    }
  }

  .insight-panel {
    font-size: 1.4rem;
    padding-left: 3.2rem;

    .btn-wrapper {
      a {
        font-size: 1.4rem;
        line-height: 1.8rem;
      }
    }
  }

  .insight-progress-bar {
    background: var(--slate-transparent);
    display: block;
    width: 0;
    height: 100%;
  }

  .insight-container {
    width: 100%;

    button {
      width: 100%;

      @media ${device.desktop} {
        width: 43.5rem;
      }
    }
  }

  .insight-container:not(.active > .insight-container) {
    border-left: 4px solid var(--slate-transparent);
  }

  &.active {
    h5 {
      color: var(--charcoal);
    }
    & .insight-progress-bar {
      width: 0.4rem;

      &:after {
        animation-duration: 6.5s;
        animation-name: insightSlideProgress;
        animation-timing-function: linear;
        animation-play-state: inherit;
        background-color: var(--bdo-red);
        content: '';
        display: block;
        height: 100%;
        width: 0.4rem;
      }
    }
  }

  .tag {
    display: inline-block;
    margin-bottom: 1.6rem;
  }

  // Keyframe animation that animates the red progress bar on the opened insight
  @keyframes insightSlideProgress {
    from {
      height: 0;
    }
    to {
      height: 100%;
    }
  }
`;

const TrendingTopicInsight = (props) => {
  const {
    title,
    description,
    buttonText,
    buttonLink,
    index,
    selectedInsightIndex,
    changeSelectedIndex,
    primaryCategory
  } = props;

  return (
    <InsightWrapper className={classNames({ active: index === selectedInsightIndex })}>
      <div className="insight-progress-bar" />
      <div className="insight-container">
        <button
          aria-expanded={index === selectedInsightIndex}
          aria-controls="insight-panel"
          onClick={() => changeSelectedIndex(index)}
        >
          {primaryCategory && <span className={`tag`}>{startcase(primaryCategory)}</span>}
          <h5>{title}</h5>
        </button>
        <AnimateHeight
          className="insight-panel"
          id="insight-panel"
          duration={500}
          height={index === selectedInsightIndex ? 'auto' : 0}
        >
          <p>{description}</p>
          <ButtonLink text={buttonText} link={buttonLink} type="tertiary" />
        </AnimateHeight>
      </div>
    </InsightWrapper>
  );
};

export default TrendingTopicInsight;
